import { useGetCounries } from "@/actions/hooks/useGetCountries.tsx";
import Flag from "@/components/Flag/Flag.tsx";
import { Flags } from "@/components/Flag/interaces/Flags.ts";
import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { PaymentFI } from "@/components/Payment/PaymentForm/enums/PaymentFI.ts";
import { getCardBrandImgURL } from "@/components/Payment/PaymentForm/getCardBrandImgURL.ts";
import { PaymentProviderEnum } from "@/helpers/types/types.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useTranslation } from "react-i18next";
import { CiCreditCard1, CiLocationOn, CiMail } from "react-icons/ci";
import { PiBriefcaseLight } from "react-icons/pi";
import { RxPerson } from "react-icons/rx";
import { useShallow } from "zustand/react/shallow";

export const HolderAndPaymentOverview = () => {
  const { t } = useTranslation();
  const { countries } = useGetCounries();
  const { holder, cardType, cardLastDigits, expiryDate, paymentData, isPaymentDisabled } = useEngineStore(
    useShallow((state) => ({
      holder: state.reservationHolderData,
      cardType: state.cardType,
      cardLastDigits: state.cardLastDigits,
      expiryDate: state.cardExpireDate,
      paymentData: state.paymentData,
      isPaymentDisabled: state.calculatedCartData?.isForcedInquiry || !state.paymentData,
    })),
  );
  const { paymentType } = useGetOrganization();

  return (
    <div className="holderAndPaymentInfo">
      <div className="holderAndPaymentInfo__holder">
        <h6>{t("holderAndPaymentOverview.holder")}</h6>
        <p className="holderAndPaymentInfo__row">
          <RxPerson />
          {holder?.[UserInfoFI.FirstName]} {holder?.[UserInfoFI.LastName]}
        </p>
        <div className="holderAndPaymentInfo__row">
          <Flag
            size="s"
            key={holder?.[UserInfoFI.Country]}
            hasBorder={true}
            code={holder?.[UserInfoFI.Country] as Flags}
          />
          {holder?.[UserInfoFI.Address]}, {holder?.[UserInfoFI.City]}
        </div>
        <p className="holderAndPaymentInfo__row">
          <CiMail />
          {holder?.[UserInfoFI.Email]}
        </p>
      </div>
      {holder?.[UserInfoFI.CompanyName] && (
        <div className="holderAndPaymentInfo__company">
          <h6>{t("holderAndPaymentOverview.company")}</h6>
          <p className={"holderAndPaymentInfo__row"}>
            <RxPerson />
            {holder?.[UserInfoFI.CompanyName]}
          </p>
          <p className="holderAndPaymentInfo__row">
            <CiLocationOn />
            {holder?.[UserInfoFI.CompanyAddress]},{" "}
            {countries.find((c) => c.iso3Code === holder?.[UserInfoFI.CompanyCountry])?.name}
          </p>
          <p className="holderAndPaymentInfo__row">
            <PiBriefcaseLight />
            {holder?.[UserInfoFI.CompanyVAT]}
          </p>
        </div>
      )}
      {!isPaymentDisabled && paymentType === PaymentProviderEnum.WsPayPer && (
        <div className="holderAndPaymentInfo__payment">
          <h6>{t("holderAndPaymentOverview.payment")}</h6>
          <p className="holderAndPaymentInfo__row">
            <CiCreditCard1 />
            {paymentData?.[PaymentFI.HolderFirstName] ?? holder?.[UserInfoFI.FirstName]}{" "}
            {paymentData?.[PaymentFI.HolderLastName] ?? holder?.[UserInfoFI.LastName]}
          </p>
          <div className="holderAndPaymentInfo__payment--card-number">
            <img height={18} src={getCardBrandImgURL(cardType!)} alt={"card"} />
            <p>**** **** **** {cardLastDigits}</p>
          </div>
          <p className="holderAndPaymentInfo__row">
            {t("holderAndPaymentOverview.cardExpires")} {expiryDate}
          </p>
        </div>
      )}
      {!isPaymentDisabled && paymentType === PaymentProviderEnum.WsPay && (
        <div className="holderAndPaymentInfo__paymentDirect">
          <h6>{t("holderAndPaymentOverview.payment")}</h6>
          <p className="holderAndPaymentInfo__row">
            <CiCreditCard1 />
            {t("creditCardPayment")}
          </p>
        </div>
      )}
    </div>
  );
};
